"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Just provides a nice *type* over the simple transient settings
 */
var socketClient_1 = require("../../socket/socketClient");
var clientSession_1 = require("./clientSession");
function setSetting(key, value) {
    socketClient_1.server.setSetting({
        sessionId: clientSession_1.getSessionId(),
        settingId: key,
        value: value
    });
}
function getSetting(key) {
    return socketClient_1.server.getSetting({
        sessionId: clientSession_1.getSessionId(),
        settingId: key
    });
}
function createSimpleSetting(key) {
    return {
        set: function (value) {
            setSetting(key, value);
        },
        get: function () {
            return getSetting(key);
        }
    };
}
/**
 * DOCTOR
 */
exports.showDoctor = createSimpleSetting('showDoctor');
/**
 * Semantic View
 */
exports.showSemanticView = createSimpleSetting('showSemanticView');
/**
 * Errors expanded
 */
exports.errorsExpanded = createSimpleSetting('errorsExpanded');
/**
 * Errors Display Mode
 */
exports.errorsDisplayMode = createSimpleSetting('errorsDisplayMode');
/**
 * File Tree expanded
 */
exports.fileTreeExpanded = createSimpleSetting('fileTreeExpanded');
/**
 * File Tree width
 */
exports.fileTreeWidth = createSimpleSetting('fileTreeWidth');
/**
 * Main panel height
 */
exports.mainPanelHeight = createSimpleSetting('mainPanelHeight');



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/state/settings.js
 ** module id = 88
 ** module chunks = 0
 **/